import React from 'react';
import { colorGray } from 'styles/layout/colors';
import PropTypes from 'prop-types';

const IconUpload = ({
  color = colorGray,
  width = '25',
  height = '25',
  className = '',
}) => (
  <svg
    viewBox="0 0 25 25"
    fill="none"
    width={width}
    height={height}
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4999 3.125C14.4182 3.125 16.341 3.86631 17.8037 5.36222C18.9387 6.52298 19.6147 7.97562 19.8697 9.48153C22.7744 9.96426 25 12.5233 25 15.625C25 19.0696 22.2569 21.875 18.8889 21.875H5.27778C2.36333 21.875 0 19.458 0 16.4773C0 13.5753 2.245 11.2293 5.05222 11.1062C4.97084 9.03884 5.66528 6.93693 7.205 5.36222C8.66658 3.86741 10.5817 3.125 12.5 3.125H12.4999ZM12.5 4.34811C10.8751 4.34811 9.25885 4.97183 8.01756 6.23681C6.58233 7.69943 5.98323 9.68485 6.20735 11.5865C6.22674 11.7468 6.17825 11.9093 6.07266 12.0301C5.96706 12.1509 5.81514 12.2201 5.65567 12.219H5.32811C3.02654 12.219 1.19048 14.0901 1.19048 16.4356C1.19048 18.7811 3.02654 20.6522 5.32811 20.6522H18.8444C21.5931 20.6522 23.8095 18.3934 23.8095 15.5923C23.8095 12.947 21.8323 10.784 19.3012 10.5498C19.0415 10.5267 18.8324 10.3214 18.8012 10.0579C18.6417 8.66111 18.0448 7.31051 16.991 6.23652C15.7508 4.97264 14.1247 4.34783 12.5 4.34783L12.5 4.34811ZM12.6968 17.7989C12.5498 17.7956 12.406 17.7309 12.3277 17.6562L9.30642 14.803C9.08112 14.599 9.06931 14.2145 9.26351 13.9916C9.4577 13.7687 9.83107 13.7542 10.0446 13.9559L12.1475 15.9443V9.80978C12.1475 9.49435 12.3932 9.23913 12.6968 9.23913C13.0004 9.23913 13.2461 9.49436 13.2461 9.80978V15.9443L15.349 13.9559C15.5625 13.7542 15.9262 13.7798 16.1301 13.9916C16.3414 14.2111 16.3017 14.6023 16.0872 14.803L13.0659 17.6562C12.9446 17.771 12.8427 17.7989 12.6968 17.7989H12.6968Z"
      fill={color}
    />
  </svg>
);

IconUpload.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconUpload;
